module.exports = __webpack_public_path__ + "storeIcon.png?19fa0c7522a3691b991657523cea5047";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storeIcon.png
// module id = 53
// module chunks = 0